import * as React from "react";
import { Row, Col, Image } from "react-bootstrap";

interface Props {
	productname: string,
	differences: {
		image: string,
		title: string,
		text: string,
	}[]
}
export default function Difference(props: Props) {
	return (
		<>
			<h2 className="difference-title">What makes EarsOnly <br />{props.productname} different?</h2>
			<Row
				xs={1}
				sm={1}
				md={1}
				lg={3}
				className="difference-row"
			>

				{props?.differences?.map((difference) => {
					return (
						<Col className="difference-col">
							<Image src={difference.image} className="difference-image" />
							<h4>{difference.title}</h4>
							<p>{difference.text}</p>
						</Col>
					)
				})}
			</Row>
		</>
	);
}
